























































































































































































import camelcaseKeysDeep from 'camelcase-keys-deep';
import Enterprise from '@/datatypes/enterprise';
import BillingProviderCustomer from '@/datatypes/billing/provider-customer';
import CustomerSearchRequest from '@/datatypes/enterprise/customer-search-request';
import CustomerCreateRequest from '@/datatypes/enterprise/customer-create-request';
import BillingCustomerService from '@/services/billing/BillingCustomerService';
import EnterpriseService from '@/services/enterprise/EnterpriseService';
import EnterpriseSubscriptionInfo from '@/components/billing/enterprise-subscription-info.vue';
import SnackbarMessageHandler from '@/components/snackbarMessage.vue';
import StripeCustomerDisplay from '@/components/stripe/customer/display.vue';
import { required, email } from 'vuelidate/lib/validators';
import Vue from 'vue';

export default Vue.extend({
  components: {
    SnackbarMessageHandler,
    EnterpriseSubscriptionInfo,
    StripeCustomerDisplay,
  },
  validations: {
    searchCustomer: {
      email: { required, email },
    },
    newCustomer: {
      name: { required },
      email: { required, email },
    },
  },
  data: () => ({
    enterprise: new Enterprise({}),
    errorMessage: '',
    enterpriseService: new EnterpriseService(),
    actionType: 'viewing',
    searchCustomer: new CustomerSearchRequest({}),
    newCustomer: new CustomerCreateRequest({}),
    billingCustomerService: new BillingCustomerService(),
    customers: [] as BillingProviderCustomer[],
    customer: new BillingProviderCustomer({}),
    searchedOnce: false,
    isConfirming: false,
    isCreatingCustomer: false,
    isRemovingCustomer: false,
    isAssigningExistingCustomer: false,
  }),

  mounted() {
    this.fetchEnterprise();
  },

  methods: {
    requestCreateCustomer(): void {
      this.isCreatingCustomer = true;
      this.newCustomer = new BillingProviderCustomer({ email: this.searchCustomer.email });
    },

    createCustomer(): void {
      const request = new CustomerCreateRequest(this.newCustomer);

      this.billingCustomerService.createCustomer(
        this.$route.params.id, request,
      ).then(() => {
        this.$router.push(`/businesses/${this.enterprise.id}/subscription`);
      });
    },

    cancelCreateCustomer(): void {
      this.isCreatingCustomer = false;
      this.newCustomer = new BillingProviderCustomer({});
    },

    fetchEnterprise(): void {
      this.enterpriseService.getEnterprise(this.$route.params.id).then((response) => {
        this.enterprise = new Enterprise(camelcaseKeysDeep(response.data));
      });
    },

    emiterrorMessage(message: string): void {
      this.errorMessage = message;
    },

    search() {
      this.searchedOnce = false;

      const searchParams = {
        email: this.searchCustomer.email,
      };

      this.billingCustomerService.searchCustomer(this.enterprise.id, searchParams).then(
        (response) => {
          this.customers = response.data.map((customer) => new BillingProviderCustomer(customer));
          this.searchedOnce = true;
        },
      );
    },

    removeCustomer() {
      this.billingCustomerService.removeCustomer(this.enterprise.id).then(() => {
        this.$router.push(`/businesses/${this.enterprise.id}/subscription`);
      });
    },

    requestAssignment(customer: BillingProviderCustomer) {
      this.customer = customer;

      if (customer.enterprise.id) {
        this.isAssigningExistingCustomer = true;
      } else {
        this.isConfirming = true;
      }
    },

    confirmAssignment() {
      if (!this.customer.id) return;

      const params = {
        customerId: this.customer.id,
      };

      this.billingCustomerService.assignCustomer(this.enterprise.id, params).then(() => {
        this.errorMessage = 'Customer assigned.';
        this.$router.push(`/businesses/${this.enterprise.id}/subscription`);
      }).catch((error) => {
        this.errorMessage = error.response.data.message;
      });
    },

    cancelAssignment() {
      this.isConfirming = false;
      this.customer = new BillingProviderCustomer({});
    },
  },

  computed: {
    enterpriseId(): string {
      return this.$route.params.id;
    },
    canNewCustomer(): boolean {
      return this.enterprise.canNewCustomer();
    },
    hasSubscription(): boolean {
      return this.enterprise.hasSubscription();
    },
  },
});
